import { supabase } from '@/lib/supabase';

export type TelemetryEvent =
  | { name: 'admin_first_login'; org_id: string; user_id: string; timestamp: string }
  | { name: 'welcome_cta_click'; step: 'invite' | 'conversation' | 'theme'; org_id: string; user_id: string; timestamp: string }
  | { name: 'overview_cta_click'; cta: 'resend_invites' | 'reengage' | 'view_insights'; org_id: string; user_id: string; timestamp: string };

const isDev = typeof import.meta !== 'undefined' && (import.meta as any).env?.DEV;

export async function emit(event: TelemetryEvent) {
  const { name, org_id, user_id, ...rest } = event as any;
  try {
    await supabase.from('telemetry_events').insert({
      org_id: org_id ?? null,
      user_id: user_id ?? null,
      event: name,
      payload: rest,
    });
  } catch {
    /* swallow */
  }
  if (isDev) {
    // eslint-disable-next-line no-console
    console.info('[telemetry]', name, event);
  }
}

/** Fires admin_first_login exactly once per (user_id, org_id), checking the persistent log. */
export async function emitFirstLoginOnce(user_id: string, org_id: string) {
  if (!user_id || !org_id) return;
  const { data, error } = await supabase
    .from('telemetry_events')
    .select('id')
    .eq('user_id', user_id)
    .eq('org_id', org_id)
    .eq('event', 'admin_first_login')
    .limit(1);
  if (error) return;
  if (data && data.length > 0) return;
  await emit({
    name: 'admin_first_login',
    org_id,
    user_id,
    timestamp: new Date().toISOString(),
  });
}
